import { GridUtils, Link } from '@atlassian/amkt-common';
import { LinkUtils } from '@atlassian/mpac-utils';
import React, { useEffect } from 'react';
import { ScreenClassRender } from 'react-grid-system';
import { ErrorView as ErrorViewStyled, ErrorViewImage, ErrorViewInner, GoBackLink, Heading, MoreInfo, Text } from './ErrorView.styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function ErrorView(props) {
  const onClickBack = event => {
    event.preventDefault();
    if (props.history) {
      props.history.goBack();
    } else {
      window.history.back();
    }
  };
  const onSearchForApps = event => {
    if (props.history) {
      LinkUtils.maybeOpenInNewTab(event, () => {
        var _props$history;
        (_props$history = props.history) === null || _props$history === void 0 ? void 0 : _props$history.push({
          pathname: props.homeLink
        });
      });
    }
  };
  const getErrorCodeText = () => {
    const {
      statusCode
    } = props;
    if (statusCode === 404) {
      return 'if you think this page should be here';
    }
    return "if this problem doesn't resolve itself";
  };
  const renderNotFound = sc => {
    const errorCodeText = getErrorCodeText();
    return /*#__PURE__*/_jsx(ErrorViewStyled, {
      padding: GridUtils.triFoldScreenClass(sc)('50px 25px', '80px 40px', '100px 50px'),
      children: /*#__PURE__*/_jsxs(ErrorViewInner, {
        children: [/*#__PURE__*/_jsx(ErrorViewImage, {
          src: props.image,
          alt: "photo depicting an error"
        }), /*#__PURE__*/_jsxs(Text, {
          children: [/*#__PURE__*/_jsx(Heading, {
            children: props.heading
          }), /*#__PURE__*/_jsxs(MoreInfo, {
            children: [/*#__PURE__*/_jsxs("span", {
              children: [props.primaryMessage, ". You can", ' ', !props.hideGoBackLink ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(GoBackLink, {
                  onClick: onClickBack,
                  children: "go back"
                }), ",", ' ']
              }) : null]
            }), /*#__PURE__*/_jsx(Link, {
              href: props.homeLink,
              onClick: onSearchForApps,
              "data-testid": "search-for-apps",
              children: "search for apps"
            }), ",", /*#__PURE__*/_jsxs("span", {
              children: [" or ", errorCodeText, ", feel free to "]
            }), /*#__PURE__*/_jsx(Link, {
              href: "http://go.atlassian.com/marketplace-support",
              rel: "noopener noreferrer",
              target: "_blank",
              children: "contact our support team"
            }), "."]
          })]
        })]
      })
    });
  };
  useEffect(() => {
    // SEO4Ajax sets onCaptureReady on window - when SEO4Ajax is rendering this error page, we can execute it
    // with a status code so that we can override the standard 200 with a more appropriate status code for it to cache
    // (or not cache, if a 5xx) and later return to bots
    if (window.onCaptureReady) {
      window.onCaptureReady(props.statusCode);
    }
  }, []);
  return /*#__PURE__*/_jsx(ScreenClassRender, {
    render: renderNotFound,
    children: /*#__PURE__*/_jsx("span", {})
  });
}